export default "__VITE_ASSET__011GDz2g__"